module.exports = __webpack_public_path__ + "static/media/contacts.8aaf0b60.svg";